import { Component } from '@angular/core'
import { StudyContainerPageService } from '../study-container-page.service';

@Component({
    selector: 'faq-page',
    templateUrl: './faq-page.html',
    styleUrls: ['./faq-page.scss']
})
export class FaqPageComponent {
    constructor(public studyContainerPageService: StudyContainerPageService) {}


    //----------------------------------
    // Lifecycle Hooks
    //----------------------------------

    ngOnInit() {
        
    }


    //----------------------------------
    // Public Methods
    //----------------------------------

}


// WEBPACK FOOTER //
// ./src/app/pages/study-container-page/faq-page/faq-page.component.ts